module.exports = __webpack_public_path__ + "img/id-verified.5d1598c4.jpg";